/**
 * @description Constants
 * @class Constants
 */
export class Constants {
  static url = {
    index: '',
    entityProducts: 'entity/products',
    entityDetail: 'entity',
    terms: 'terms',
    messages: 'messages',
    nopsd2: 'nopsd2',
    entity: 'entity',
    back: 'can-go-back',
    params: 'params',
    type: 'type',
    language: 'language',
    appId: 'app-unique-id',
    propId: 'prop-unique-id',
    loader: 'loader'
  };
  static language = 'language';

  static santanderCode = 'PRV72400000049';

  static statusNames = {
    ok: 'OK',
    success: 'success',
    ko: 'KO',
    oncourse: 'oncourse',
    validating: 'VALIDATING',
    nonOwner: 'NON_OWNER_ACCOUNT',
    error: 'error'
  };

  static entryParamsCookieName = 'app_params';

  static entityType = {
    psd2: 'PSD2',
    noPsd2: 'NOPSD2'
  };
  static entityPSD2Type = {
    a1: 'A1',
    a2: 'A2'
  };

  static consentOk = 'consentPreviouslyOk';

  static windowEvents = {
    message: 'message',
    loginId: 'received-login',
    consentOk: 'received-callback-ok',
    consentKo: 'received-callback-ko'
  };

  static banksWithImages = [
    'NovoBanco',
    'CaixaColonya',
    'ING',
    'RevolutSpain',
    'N26BankSpain',
    'ImaginBank',
    'CajaLaboral',
    'EurocajaRural',
    'CaixaGuissona',
    'SelfBank',
    'BancaMarch',
    'BancaPueyo',
    'AndBank',
    'Mediolanum',
    'DeutscheBankAlt',
    'Kutxabank',
    'Ibercaja',
    'Qonto',
    'CajadeIngenieros',
    'Ruralvia',
    'Caixabank',
    'Openbank',
    'Arquia',
    'Pibank',
    'TriodosBank',
    'Abanca',
    'BBVA',
    'Sabadell',
    'CaixaOntinyent',
    'Bankinter',
    'BancoPichincha',
    'CaixaRuralTorrent',
    'Unicaja',
    'Bancofar',
    'Renta4',
    'BancoCaminos',
    'Cajamar',
    'BancoFinantiaSofinloc',
    'CajaRuraldeAlmendralejo',
    'cecabank',
    'FiareBancaEtica',
    'inversis',
    'Wizink'
  ];

  static internalAppParams = [
    'token',
    'redirectUri',
    'appKey',
    'iswebview',
    'language',
    'consentId',
    'ASPSP',
    '_dwtk'
  ];

  /**
   *
   */
  constructor() { }
}
